exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HSIDLogo_Logo_3Gw2t {\n    background-color: white;\n    height: auto;\n    box-sizing: border-box;\n    color: #282c34;\n}\n\n.HSIDLogo_Logo_3Gw2t img {\n    height: 45px;\n    display: block;\n    margin: auto;\n}", ""]);

// Exports
exports.locals = {
	"Logo": "HSIDLogo_Logo_3Gw2t"
};